module.exports = __webpack_public_path__ + "static/img/img-coupon-list01.af89716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-coupon-list01.png
// module id = 0xR4
// module chunks = 1